export function floatToPercent(float: number): string {
  return `${Math.round(float * 100)}%`;
}